export default __webpack_public_path__ + "static/media/Sweatshirts.fe60a618.png";